import { RootState } from 'rootReducer';

export const commonTripSelector = (state: RootState) => state.commonReducer.commonTripReducer;
export const tripSavedSelector = (state: RootState) => ({
  saved: state.commonReducer.commonTripReducer.saved,
  forceSave: state.commonReducer.commonTripReducer.forceSave,
});

export const tripCommonTripSelector = (state: RootState) => state.commonReducer.commonTripReducer.trip;
export const tripOrdersSel = (state: RootState) => state.commonReducer.commonTripReducer.trip.orders;
export const dataDocsSelector = (state: RootState) => state.commonReducer.commonTripReducer.docsData;
export const visitorSelector = (state: RootState) => state.commonReducer.commonTripReducer.visitor;
